import { useCallback } from 'react';
import { preferencesReducer } from '@core/store/entity/preferences/PreferencesReducer';
import { useEntityThunk } from '@hwm/ui-lib';
import { PreferencesFormModel, PreferencesOptionsModel } from '@shared/models';
import { t } from '@lingui/macro';
import { useApi } from '@core/http/useApi';
import { applicationPaths } from '@core/http/applicationPaths';
import { useNotifications } from '@shared/hooks/useNotifications';

export const usePreferencesDataSource = () => {
  const { handleSuccess, handleError } = useNotifications();

  const [getPreferences, getLoading] = useEntityThunk(preferencesReducer.thunks.getPreferences);

  const [savePreferences, saveLoading] = useEntityThunk(preferencesReducer.thunks.savePreferences);

  const [getPreferencesOptions, preferencesOptions, preferencesOptionsLoading] = useApi<PreferencesOptionsModel>(
    applicationPaths.preferences.options,
    'get'
  );

  const handleGetPreferences = useCallback(() => {
    getPreferences().catch((err) =>
      handleError(err, t`Preferences`, t`There was a problem while trying to get preferences`)
    );
  }, [getPreferences, handleError]);

  const handleSavePreferences = useCallback(
    (data: PreferencesFormModel, cb?: () => void) => {
      savePreferences({ body: data })
        .then(() => {
          handleSuccess(t`Preferences successfully saved`, t`Preferences`);
          setTimeout(() => cb?.(), 200);
        })
        .catch((err) => handleError(err, t`Preferences`, t`There was a problem while trying to save preferences`));
    },
    [savePreferences, handleSuccess, handleError]
  );

  const handleGetPreferencesOptions = useCallback(() => {
    getPreferencesOptions().catch((err) =>
      handleError(err, t`Preferences`, t`There was a problem while trying to get channel type units`)
    );
  }, [getPreferencesOptions, handleError]);

  return {
    getPreferences: handleGetPreferences,
    savePreferences: handleSavePreferences,
    getPreferencesOptions: handleGetPreferencesOptions,
    preferencesOptions,
    loading: getLoading || saveLoading || preferencesOptionsLoading,
  };
};
